import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NodesService } from '../service/nodes.service';
import { Node } from '../model/node.model';
import { NodeHistory } from '../model/node-history.model';
import { StudentService } from '../../children/service/student.service';

@Component({
    selector: 'node-status-table-item',
    templateUrl: './node-status-table-item.component.html',
    styleUrls: ['./node-status-table-item.component.scss']
})
export class NodeStatusTableItemComponent implements OnInit {
    @Input() node!: Node;
    @Input() studentId!: number;
    @Input() coeId!: number;
    @Input('nodeId') nodeId!: number;
    @Input('nodeHistory') nodeHistory: NodeHistory[];
    @Input() doNotSearch: boolean = false;
    @Output() nodeChange = new EventEmitter<Node>();

    nodeID: number;
    nodeHistories: NodeHistory[];

    isLoading: boolean = false;
    promises: Array<any> = [];

    output: any = {
        currentState: '',
        completedState: '',
        class: '',
        sameState: false
    };

    constructor(
        private nodeService: NodesService,
        private studentService: StudentService
    ) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.isLoading = true;
        if (this.node && this.node.ID)
            this.nodeID = this.node.ID; //node object is present when called from COE
        else this.nodeID = this.nodeId; //node object not available when caled from Workbench hence passing node ID to use the common component

        if (!this.doNotSearch) {
            this.getHistories();
        } else {
            this.nodeHistories = this.node.NODE_HISTORIES;
        }

        Promise.all(this.promises).then((res) => {
            this.promises = [];
            this.refreshNodeResult();

            Promise.all(this.promises).then((res) => {
                this.nodeChange.emit(this.node);
                this.isLoading = false;
            });
        });
    }

    getHistories() {
        let deferred = new Promise((resolve, reject) => {
            this.nodeService.getHistories(this.nodeID).subscribe((res) => {
                if (res.histories) {
                    this.nodeHistories = res.histories;

                    if (this.node) this.node.NODE_HISTORIES = this.nodeHistories;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    refreshNodeResult() {
        let promises = [];

        this.nodeHistories.forEach((history) => {
            if (history.WORKFLOW_STATE_TYPES.NAME === 'Removed Child State' || history.WORKFLOW_STATE_TYPES1.NAME === 'Removed Child State') {
                if (this.studentId && this.coeId) {
                    let deferred = new Promise((resolve, reject) => {
                        this.studentService.verifyCoe(this.studentId, this.coeId).subscribe((res) => {
                            if (res?.msg) {
                                if (res.msg.SUCCESS) {
                                } else {
                                    this.output.removedChild = true;
                                }
                            } else {
                                this.output.removedChild = true;
                            }

                            resolve(null);
                        });
                    });

                    promises.push(deferred);
                } else {
                    this.output.removedChild = true;
                }
            }
            if (history.WORKFLOW_STATE_TYPES.NAME === 'COE Ineligible State' || history.WORKFLOW_STATE_TYPES1.NAME === 'COE Ineligible State') {
                this.output.coeIneligible = true;
            }
            if (history.WORKFLOW_STATE_TYPES.NAME === 'Approved State' || history.WORKFLOW_STATE_TYPES1.NAME === 'Approved State') {
                this.output.approved = true;
            }
            if (history.WORKFLOW_STATE_TYPES.NAME === 'Denied State' || history.WORKFLOW_STATE_TYPES1.NAME === 'Denied State') {
                this.output.denied = true;
            }
            if (history.WORKFLOW_STATE_TYPES.NAME === 'Void State' || history.WORKFLOW_STATE_TYPES1.NAME === 'Void State') {
                this.output.voided = true;
            }
        });

        Promise.all(this.promises).then((res) => {
            if (this.output.voided) {
                this.output.result = 'Voided';
                this.output.class = 'output-danger';
            } else if (this.output.coeIneligible) {
                this.output.result = 'COE Ineligible';
                this.output.class = 'output-danger';
            } else if (this.output.removedChild) {
                this.output.result = 'Removed Child';
                this.output.class = 'output-danger';
            } else if (this.output.approved) {
                this.output.result = 'Approved';
                this.output.class = 'success';
            } else if (this.output.denied) {
                this.output.result = 'Denied';
                this.output.class = 'output-danger';
            }

            if (this.node) {
                if (this.node.WORKFLOW_STATE_TYPES.NAME === 'Approved State') {
                    this.output.result = 'Approved';
                    this.output.class = 'success';
                } else if (this.node.WORKFLOW_STATE_TYPES.NAME === 'Denied State') {
                    this.output.result = 'Denied';
                    this.output.class = 'output-danger';
                }
            }

            this.checkSameState();
        });
    }

    checkSameState() {
        if (this.node) {
            if (this.node.NODE_HISTORIES && this.node.NODE_HISTORIES.length > 1) {
                if (this.node.NODE_HISTORIES[this.node.NODE_HISTORIES.length - 1].WORKFLOW_STATE_TYPES1.DESCRIPTION.includes(this.output.result)) {
                    this.output.sameState = true;
                }
            } else {
                if (this.node.WORKFLOW_STATE_TYPES.DESCRIPTION && this.node.WORKFLOW_STATE_TYPES.DESCRIPTION.includes(this.output.result)) {
                    this.output.sameState = true;
                }
            }
        } else if (this.nodeHistory) {
            if (this.nodeHistory.length > 0) {
                if (this.nodeHistory[this.nodeHistory.length - 1].WORKFLOW_STATE_TYPES1.DESCRIPTION.includes(this.output.result)) {
                    this.output.sameState = true;
                }
            }
        }
    }
}
